import { AuthLayout } from '@ui/components/layouts';
import { LoginContainer } from '@modules/login/containers/login_container';
import { LoginForm } from '@modules/login/views/login_view';
import { AuthPublicPageContainer } from '@/src/components/AuthPublicPageContainer';
import { webAppRoutes } from '@/src/lib/navigation/containerPaths';

export function LoginScreen() {
  return (
    <AuthPublicPageContainer>
      {({ onSuccess, onError, onSuccessNavigate, navigate }) => (
        <AuthLayout>
          <LoginContainer
            View={LoginForm}
            onSuccess={onSuccess}
            onError={onError}
            onSuccessNavigate={onSuccessNavigate}
            onNavigateToSignUp={() => navigate(webAppRoutes.signUp)}
            onNavigateToForgotPassword={() => navigate(webAppRoutes.forgotPassword)}
            useFormSubmitHandler
          />
        </AuthLayout>
      )}
    </AuthPublicPageContainer>
  );
}
